import { createSlice } from "@reduxjs/toolkit";
import {
  EventInitialStatus,
  GetEventData,
  GetSingleEventData,
} from "../../../../types/eventManage/event";
import {
  createEventAsync,
  getAllEventsAsync,
  singEventDataAsync,
  updateEventAsync,
} from "./eventApi";

const initialState: EventInitialStatus<GetEventData, GetSingleEventData> = {
  loading: false,
  manageLoading: false,
  eventList: [],
  singleEventData: null,
  countEvent: 0,
};

const manageEventSlice = createSlice({
  name: "admin-event",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createEventAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createEventAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createEventAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllEventsAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllEventsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.eventList = action.payload.data;
        state.countEvent = action.payload.length;
      })
      .addCase(getAllEventsAsync.rejected, (state) => {
        state.loading = false;
        state.eventList = [];
        state.countEvent = 0;
      });

    // update
    builder
      .addCase(updateEventAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateEventAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateEventAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // single
    builder
      .addCase(singEventDataAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleEventData = null;
      })
      .addCase(singEventDataAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleEventData = action.payload;
      })
      .addCase(singEventDataAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleEventData = null;
      });
  },
});

export default manageEventSlice;
